import { apiClient } from 'api'
import { ConfirmPhone, SetPassword, User } from 'types'
import { ApiResponse } from '../types/api'

export const getCurrentUserInfo = () => apiClient.get<ApiResponse<User>>('/users/me')

export const confirmPhone = (data: ConfirmPhone) => apiClient.post<ConfirmPhone, unknown>('/users/confirm-phone', data)

export const setUserPassword = (data: SetPassword) => apiClient.post<SetPassword, unknown>('users/set-password', data)
